export enum SymbolType {
    TREASURE_CHEST = 'treasure_chest',
    NEON_DIAMOND = 'neon_diamond',
    SHOWGIRL_HAT = 'showgirl_hat',
    SPORTS_CAR = 'sports_car',
    DICE = 'dice',
    MARTINI = 'martini',
    COINS = 'coins',
    HORSESHOE = 'horseshoe',
    ACE = 'ace',
    KING = 'king',
    QUEEN = 'queen',
    JACK = 'jack',
    TEN = 'ten',
    WILD = 'wild',
    SCATTER = 'scatter',
    MINI_GAME = 'mini_game'
}

export interface Symbol {
    id: SymbolType;
    name: string;
    image: string;
    isWild: boolean;
    isScatter: boolean;
    tier: 'high' | 'mid' | 'low' | 'special';
}

export interface PaytableEntry {
    symbol: SymbolType;
    count: number;
    payout: number;
}

export interface ReelStrip {
    symbols: SymbolType[];
    weights?: number[];
}

export interface SpinResult {
    reels: SymbolType[][];
    wins: WinLine[];
    totalWin: number;
    scatterCount: number;
    triggeredFeatures: string[];
}

export interface WinLine {
    lineNumber: number;
    symbols: SymbolType[];
    positions: { reel: number; row: number }[];
    payout: number;
    symbolCount: number;
}

export interface GameConfig {
    reels: number;
    rows: number;
    paylines: number[][][];
    minBet: number;
    maxBet: number;
    defaultBet: number;
    targetRTP: number;
    hitRate: number;
    volatility: 'low' | 'medium' | 'medium-high' | 'high';
}

export interface GameState {
    balance: number;
    betPerLine: number;
    activeLines: number;
    totalBet: number;
    isSpinning: boolean;
    isAutoplay: boolean;
    autoplayRemaining: number;
    freeSpinsRemaining: number;
    freeSpinsMultiplier: number;
    turboMode: boolean;
    lastWin: number;
    sessionWins: number;
    sessionLosses: number;
}

export interface FeatureConfig {
    freeSpins: {
        triggerCount: number;
        spinsAwarded: number;
        multiplier: number;
        retriggerAllowed: boolean;
        triggerChance: number;
    };
    randomWild: {
        chance: number;
        minWilds: number;
        maxWilds: number;
    };
    megaSymbol: {
        chance: number;
        size: number;
        eligibleSymbols: SymbolType[];
    };
}

export interface AdminSettings {
    rtp: {
        target: number;
        baseGame: number;
        freeSpins: number;
        features: number;
    };
    paytable: Map<string, number[]>;
    reelStrips: ReelStrip[];
    features: FeatureConfig;
    ui: {
        theme: string;
        soundEnabled: boolean;
        musicVolume: number;
        sfxVolume: number;
    };
}